"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedPromptDependencySchema = exports.PromptDependencyRegex = void 0;
exports.parsePromptDependencyTags = parsePromptDependencyTags;
const zod_1 = require("zod");
exports.PromptDependencyRegex = /@@@entellicaPrompt:(.*?)@@@/g;
exports.ParsedPromptDependencySchema = zod_1.z.union([
    zod_1.z.object({
        name: zod_1.z.string(),
        type: zod_1.z.literal("version"),
        version: zod_1.z.coerce.number(),
    }),
    zod_1.z.object({ name: zod_1.z.string(), type: zod_1.z.literal("label"), label: zod_1.z.string() }),
]);
function parsePromptDependencyTags(content) {
    const matchedTags = JSON.stringify(content).match(exports.PromptDependencyRegex);
    const validTags = [];
    for (const match of new Set(matchedTags ?? [])) {
        const innerContent = match.replace(/^@@@entellicaPrompt:|@@@$/g, "");
        const parts = innerContent.split("|");
        const params = {};
        // Check if the first parameter is name
        const firstPart = parts[0];
        if (!firstPart || !firstPart.startsWith("name=")) {
            continue; // Skip this tag if name is not the first parameter. This makes it easier to replace the tag with the resolved prompt.
        }
        // There can be only 2 parts
        if (parts.length !== 2) {
            continue;
        }
        parts.forEach((part) => {
            const [key, value] = part.split("=");
            params[key] = value;
        });
        if (params.name) {
            const parsed = exports.ParsedPromptDependencySchema.safeParse({
                name: params.name,
                ...(params.version
                    ? { version: params.version, type: "version" }
                    : { label: params.label, type: "label" }),
            });
            if (parsed.success) {
                validTags.push(parsed.data);
            }
        }
    }
    return validTags;
}
